import React from "react"
import { ConnectedRouter as Router } from "react-router-redux"
import {
  ConnectedRoute as Route,
  ConnectedSwitch as Switch,
  ConnectedRedirect as Redirect,
} from "./lib/connectedRouting"
import { formatRoute } from "./helpers/sharedHelperFunctions"
import { ApolloProvider } from "react-apollo"
import { Provider } from "react-redux"
import ErrorBoundary from "./components/ErrorBoundary"
import ContextualHeader from "./components/Header/ContextualHeader"
import DefaultRoute from "./routes/DefaultRoute"
import DetailView from "./routes/DetailView"
import Overview from "./routes/Overview"
import { RoundingMonitor } from "./routes/RoundingMonitor"
import HistoryView from "./routes/HistoryView"
import NotFound from "./routes/NotFound"
import storeWithHistory from "./store"
import routes from "./routes"
import apolloClient from "./lib/apolloClient"
import "./App.scss"

/* istanbul ignore next */
if (process.env.NODE_ENV === "production")
  window.Raven.config(process.env.REACT_APP_SENTRY_RAVEN_KEY, {
    environment: process.env.REACT_APP_STAGE,
    release: process.env.REACT_APP_SENTRY_RELEASE,
  }).install()

// The following is the app without being wrapped in apollo or a router. Exported for testing.
export const FunctionalApp = () => {
  return (
    <div className="App">
      <ContextualHeader />
      <ErrorBoundary>
        <Switch>
          <Route path={routes.root} exact component={DefaultRoute} />
          <Route
            exact
            path={routes.entity}
            render={({ match: { params } }) => (
              <Redirect to={formatRoute(routes.overview, params)} /> // redirect from /facility/7 to /facility/7/overview
            )}
          />
          <Route path={routes.overview} exact component={Overview} />
          <Route
            path={routes.roundingMonitor}
            exact
            component={RoundingMonitor}
          />
          <Route
            path={routes.roundingMonitorNested}
            exact
            component={RoundingMonitor}
          />
          <Route path={routes.detail} exact component={DetailView} />
          <Route
            path={routes.nestedEntityOverview}
            exact
            render={props => <Overview isNestedEntity {...props} />}
          />
          <Route path={routes.nestedEntityDetail} exact>
            <DetailView secondaryNav />
          </Route>
          <Route path={routes.entityDetail} exact component={HistoryView} />
          <Route path={routes.error} exact component={ErrorBoundary} />
          <Route component={NotFound} />
        </Switch>
      </ErrorBoundary>
      <footer className="footer" />
    </div>
  )
}

const { store, history } = storeWithHistory()

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <ApolloProvider client={apolloClient}>
          <Router history={history}>
            <FunctionalApp />
          </Router>
        </ApolloProvider>
      </Provider>
    )
  }
}

export default App
